import { SingleLayout, HomeSchoolForm } from 'components';
import React from 'react';
import { UiHomeSchoolFormPage } from './HomeSchoolFormPage.style';


/**
 * 學校教師，新增班級頁面
 */

export const HomeSchoolFormPage = props => {
  return (
    <SingleLayout>
      <UiHomeSchoolFormPage>
        <HomeSchoolForm {...props} />
      </UiHomeSchoolFormPage>
    </SingleLayout>
  );
};
